module.exports = __webpack_public_path__ + "static/media/delete.c4f90a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/delete.png
// module id = 306
// module chunks = 2